import { render } from "./BalanceInfo.vue?vue&type=template&id=7efa8c04&scoped=true"
import script from "./BalanceInfo.vue?vue&type=script&lang=js"
export * from "./BalanceInfo.vue?vue&type=script&lang=js"

import "./BalanceInfo.vue?vue&type=style&index=0&id=7efa8c04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efa8c04"]])

export default __exports__